import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import Main from "../../components/Layout/Main";
import CoverImage from "../../components/CoverImage";
import PressQuotes from '../../components/PressQuotes/PressQuotes';

const Press = () => {
  const { markdownRemark } = useStaticQuery(graphql`
    query PressQuery {
      markdownRemark(frontmatter: { pageId: { eq: "press-page" } }) {
        frontmatter {
          components {
            type
            headline
            body {
              line
            }
            attr
            quotes {
              quote
              source
            }
            image {
              childImageSharp {
                fluid(maxWidth: 2048, quality: 80) {
                  ...GatsbyImageSharpFluid
                }
              }
              extension
              publicURL
            }
          }
        }
      }
    }
  `)

  function getComponent(name) {
    const components = markdownRemark.frontmatter.components;
    return components.filter(component => component.type === name)[0];
  }

  const CoverImageContent = getComponent("coverImage");
  const pressQuote1Content = getComponent("pressQuote1");
  const CoverImage2Content = getComponent("coverImage2");
  const pressQuote2Content = getComponent("pressQuote2");

  return (
    <Main>
      <CoverImage
        image={CoverImageContent.image}
        headline={CoverImageContent.headline}
        hero="hero"
      />
      <PressQuotes quotes={pressQuote1Content.quotes}/>
      <CoverImage
        image={CoverImage2Content.image}
        variant="singleFrame"
      />
      <PressQuotes quotes={pressQuote2Content.quotes}/>
    </Main>
  );
}

export default Press
